import {
  Component,
  Input,
  ContentChild,
  ViewEncapsulation
} from '@angular/core';
import { MdlTabPanelTitleComponent } from './mdl-tab-panel-title.component';


export class MdlTabPanelContent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-tab-panel-content',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class MdlTabPanelComponent {

   public titleComponent;
   public title;
   public disabled;
  public isActive = false;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-tab-panel',
  host: {
    '[class.mdl-tabs__panel]': 'true',
    '[class.is-active]': 'isActive'
  },
  template:
    `
   <ng-content *ngIf="titleComponent" select="mdl-tab-panel-content"></ng-content>
   <ng-content *ngIf="!titleComponent"></ng-content>
   `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'titleComponent': [{ type: ContentChild, args: [MdlTabPanelTitleComponent, ] },],
'title': [{ type: Input, args: ['mdl-tab-panel-title', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
